export default __webpack_public_path__ + "static/media/Twitter-logo.24376802.svg";